import { render, staticRenderFns } from "./project-props.vue?vue&type=template&id=11c6f83a&"
import script from "./project-props.vue?vue&type=script&lang=js&"
export * from "./project-props.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports